import T, { t } from '../../../common/components/T';
import { replaceUrl } from '../../../common/utils/router';
import uikit from '../../../project/uikit/styles';
import css from './Register.module.scss';

export const getFormData = (translation, data) => [
    // {
    //     placeholder: (
    //         <T textName='register-fields-sponsor_username-placeholder' defaultStr='Кто вас пригласил' page='/authentication' />
    //     ),
    //     attribute: 'sponsor_username',
    //     title: {
    //         body: <T textName='register-fields-sponsor_username-title' defaultStr='У Вас есть спонсор?' page='/authentication' />
    //     },
    //     type: 'sponsor-widget',
    //     value: null
    // },
    {
        attribute: 'sponsor_username',
        type: 'input',
        title: {
            body: <T textName='register-fields-sponsor-username-title' defaultStr='ID спонсора' page='/authentication' />
        },
        placeholder: (
            <T textName='register-fields-sponsor-username-placeholder' defaultStr='KAZ001180100002' page='/authentication' />
        ),
        required: true
    },
    {
        attribute: 'sponsor_lastname',
        type: 'input',
        title: {
            body: (
                <T
                    textName='register-fields-sponsor-username-lastname-title'
                    defaultStr='Фамилия спонсора'
                    page='/authentication'
                />
            )
        },
        disabled: true,
        value: data?.data?.last_name
    },
    {
        attribute: 'sponsor_firstname',
        type: 'input',
        title: {
            body: (
                <T textName='register-fields-sponsor-username-firstname-title' defaultStr='Имя спонсора' page='/authentication' />
            )
        },
        disabled: true,
        value: data?.data?.first_name
    },
    {
        attribute: 'line',
        type: 'info-field',
        html: <div className={css.line}></div>
    },
    // {
    //     placeholder: 'johndoe',
    //     attribute: 'username',
    //     required: true,
    //     title: {
    //         body: <T textName='register-fields-username-title' defaultStr='Ваш логин' page='/authentication' />
    //     },
    //     type: 'input'
    // },
    {
        attribute: 'country_id',
        required: true,
        type: 'location_widget',
        title: {
            body: <T textName='register-fields-country-title' defaultStr='Выберите страну' page='/authentication' />
        }
    },
    {
        attribute: 'last_name',
        type: 'input',
        required: true,
        title: {
            body: <T textName='register-fields-lastname-title' defaultStr='Введите фамилию' page='/authentication' />
        }
    },
    {
        attribute: 'first_name',
        type: 'input',
        required: true,
        title: {
            body: <T textName='register-fields-firstname-title' defaultStr='Введите имя' page='/authentication' />
        }
    },
    {
        attribute: 'line',
        type: 'info-field',
        html: <div className={css.line}></div>
    },
    {
        attribute: 'email',
        required: true,
        title: {
            body: <T textName='register-fields-email-title' defaultStr='Введите email' page='/authentication' />
        },
        type: 'input'
    },
    {
        placeholder: '******',
        attribute: 'password',
        required: true,
        title: {
            body: <T textName='getFormData-password-title' defaultStr='Введите пароль' page='/authentication' />
        },
        type: 'password'
        // tooltip: <T textName='getFormData-password-tooltip' defaultStr='Данное поле должно содержать только латинские символы, цифры, а также спец. символы. Минимальная длина данного поля должна быть от 6 символов.' page='/authentication' />,
    },
    {
        placeholder: '******',
        attribute: 'password_confirmation',
        required: true,
        title: {
            body: (
                <T
                    textName='register-fields-password_confirmation-title'
                    defaultStr='Подтвердите пароль'
                    page='/authentication'
                />
            )
        },
        type: 'password'
        // tooltip: <T textName='register-fields-password_confirmation-tooltip' defaultStr='Значение поля должно соотвествовать значению поля "Пароль".' page='/authentication' />
    },
    {
        attribute: 'agreement',
        required: true,
        type: 'checkbox',
        title: {
            body: t(
                'register-fields-agreement-new',
                'Я принимаю условия ${distribution_agreement} и ${business_code}',
                '/authentication',
                translation
            ),
            links: {
                distribution_agreement: {
                    href: 'https://globaltrendcompany.com/assets_current/f23e2d5c/assets/files/distributor-agreement.pdf',
                    title: (
                        <T
                            textName='register-fields-distribution_agreement'
                            defaultStr='дистрибьюторского договора'
                            page='/authentication'
                        />
                    ),
                    target: '_blank'
                },
                business_code: {
                    href: 'https://globaltrendcompany.com/assets_current/f23e2d5c/assets/files/business-codex-gtc.pdf',
                    title: <T textName='register-fields-business_code' defaultStr='бизнес кодекса' page='/authentication' />,
                    target: '_blank'
                }
            }
        }
    },
    {
        name: 'email_verification_client_url',
        attribute: 'email_verification_client_url',
        value: replaceUrl('/verify'),
        type: 'input'
    }
];
export const getFormStyles = () => ({
    email_verification_client_url: { wrapper: { display: 'none' } },
    agreement: {
        label: {
            alignItems: 'flex-start',
            ...uikit.small,
            lineHeight: '1.28',
            marginBottom: 0
        },
        wrapper: css.agreementWrapper
    },
    sponsor_lastname: {
        wrapper: css.w50
    },
    sponsor_firstname: {
        wrapper: css.w50
    },
    last_name: {
        wrapper: css.w50
    },
    first_name: {
        wrapper: css.w50
    },
    line: { wrapper: css.lineWrapper }
});
